<!--补录数据(手工录入)页面-->
<template>
  <div class="page-container">
    <Header></Header>

    <div class="main-layout">
      <div class="sidebar">
        <MenuList></MenuList>
      </div>

      <div class="content">
        <!-- 操作栏 -->
        <div class="action-bar">
          <el-button type="primary" plain size="small" @click="backToList">
            <i class="el-icon-arrow-left"></i>返回补录数据
          </el-button>
        </div>

        <!-- 表格信息卡片 -->
        <div class="info-card">
          <h2 class="form-title">{{form_name}}</h2>
          <div class="form-meta">
            <span class="meta-item">
              <i class="el-icon-search"></i>
              <span>领表查询条件：<strong>{{showConditions()}}</strong></span>
            </span>
          </div>
        </div>

        <!-- 录入表单 -->
        <div class="table-container">
          <div class="form-box">
            <div v-for="(field,index) in fields" :key="index" class="field-item">
              <div class="field-label">
                <span v-if="isSearchCondition(field.field_name)" class="required-star">*</span>
                {{index+1}}.{{field.field_name}}
              </div>
              <div class="field-input">
                <el-input v-model="fieldValues[index]" type="text" placeholder="请输入内容"></el-input>
              </div>
            </div>
          </div>

          <div class="submit-bar">
            <el-button type="primary" @click="saveData">立即保存</el-button>
            <el-button @click="backToList">取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        form_id: '',
        form_name: '',
        fields: [],
        fieldValues: [],
        conditions: [],
        saving: false
      }
    },
    created() {
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

      this.loadFields()
    },
    methods: {
      loadFields() {
        let that = this
        var requestUrl = '/checking/web/_load_manual_input_fields.jsp'
        this.axios.get(requestUrl, {
          params: {
            form_id: that.form_id
          }
        }).then(function (response) {
          if (response.data.result === '1') {
            that.fields = response.data.fields || []
            that.conditions = response.data.conditions || []
            that.form_name = that.form_name || response.data.form.form_name

            that.fieldValues = []
            for (var i = 0; i < that.fields.length; i++) {
              that.fieldValues.push('')
            }
          }
        }).catch(function (error) {
          console.log(error)
        })
      },
      isSearchCondition(field_name) {
        for (var i = 0; i < this.conditions.length; i++) {
          if (this.conditions[i].condition_name === field_name) {
            return true
          }
        }

        return false
      },
      showConditions() {
        if (this.conditions.length === 0) {
          return '无'
        }

        return this.conditions.map(c => c.condition_name).join('，')
      },
      // 从上到下逐个校验,每次只提示第一个没有填写的项
      formIsValid() {
        for (var i = 0; i < this.fields.length; i++) {
          var field_name = this.fields[i].field_name

          if (this.isSearchCondition(field_name)) {
            var value = this.fieldValues[i]

            if (typeof value === 'undefined' || value === null || String(value) === '') {
              this.$message.error('请输入：' + field_name)

              return false
            }
          }
        }

        return true
      },
      saveData() {
        if (!this.formIsValid()) {
          return
        }

        this.saving = true

        var saveFields = []
        for (var i = 0; i < this.fields.length; i++) {
          saveFields.push({
            field_name: this.fields[i].field_name,
            field_value: this.fieldValues[i] === null || this.fieldValues[i] === undefined ? '' : this.fieldValues[i]
          })
        }

        let that = this

        var requestUrl = '/checking/web/_save_manual_input_content.jsp'

        var qs = require('qs')

        this.axios.post(requestUrl, qs.stringify({
          form_id: that.form_id,
          fields: JSON.stringify(saveFields)
        }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          that.saving = false

          if (response.data.result === '1') {
            that.$message.success('保存成功！')
            that.backToList()
          } else {
            that.$message.error(response.data.message || '保存失败,请稍候再试！')
          }
        }).catch(function (error) {
          console.log(error)
          that.saving = false
        })
      },
      backToList() {
        this.$router.push({
          name: 'manual_input_list',
          params: {
            form_id: this.form_id,
            form_name: this.form_name
          }
        })
      }
    }
  }
</script>

<style scoped>
  .page-container {
    min-height: 100vh;
    background: #f5f7fa;
    display: flex;
    flex-direction: column;
  }

  .main-layout {
    flex: 1;
    display: flex;
  }

  .sidebar {
    width: 220px;
    background: #fff;
    border-right: 1px solid #e8ecf1;
    flex-shrink: 0;
  }

  .content {
    flex: 1;
    padding: 20px;
    overflow: auto;
  }

  .action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .info-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px 24px;
    margin-bottom: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  }

  .form-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0 0 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
  }

  .form-meta {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .meta-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #666;
  }

  .meta-item i {
    color: #1485FB;
    font-size: 16px;
  }

  .table-container {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  }

  .form-box {
    padding: 10px 0;
  }

  .field-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .field-label {
    width: 240px;
    flex-shrink: 0;
    font-size: 15px;
    color: #333;
    padding-right: 16px;
    text-align: right;
  }

  .required-star {
    color: #f56c6c;
    font-weight: 700;
  }

  .field-input {
    flex: 1;
    max-width: 520px;
  }

  .submit-bar {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 24px 0 8px;
    border-top: 1px solid #f0f0f0;
  }

  @media (max-width: 768px) {
    .sidebar {
      display: none;
    }

    .content {
      padding: 12px;
    }

    .field-item {
      flex-direction: column;
      align-items: stretch;
    }

    .field-label {
      width: auto;
      text-align: left;
      padding-bottom: 8px;
    }

    .field-input {
      max-width: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/manual_input_form.vue